import { render, staticRenderFns } from "./LawExam.vue?vue&type=template&id=245b3cfb&"
import script from "./LawExam.vue?vue&type=script&lang=js&"
export * from "./LawExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports